import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class GroupMenu extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="propartes-area pd-top-20">
				<section id='splmenu'>					
					<div className="section-title text-center">
						<h2>SPECIAL MENU</h2>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
				</section>
				<section id='grpmenu'>					
					<div className="section-title text-center">
						<h2>GROUP MENU</h2>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
					<div className="container">	
						<div className="row">
							<div className="col-lg-12 text-center">
								<h4 className="mb-3">MENU KAHDELLE MENU FOR TWO</h4>
								<h6>VEGETABLE SOUP(ALKURUOKA) ( L G )</h6>
								<p>Thick mixed vegetable soup with coconut flavour</p>
								<h6>LAMB KARAI (PÄÄRUOKA) ( L G )</h6>
								<p>Stewed lamb pieces in tomato, onion, ginger and garlic sauce (medium hot)</p>	
								<h6>CHICKEN GUSTAVA(PÄÄRUOKA) ( G )</h6>
								<p>Herb and youghurt marinated tandoori chicken fillet in almond and cream sauce</p>	
								<h6>KULFI(JÄLKIRUOKA)</h6>
								<p>Nepalese ice cream made of milk, pistachio and cashew nut</p>				
							</div>
						</div>
					</div>
				</section>
				<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
					<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header">
						<h6 class="modal-title" id="exampleModalLongTitle">IMPORTANT NOTICE TO THE CUSTOMER</h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						</div>
						<div class="modal-body">
							<p className="text-success p-13">HUOM! Ӓla unhoda kysyӓ jos sinulla on minkӓӓnlaisia allergioita yrteista ja mausteista…<br/>
							NOTE: [Please do not forget to ask if you have any allergies on herbs, spices or foods]</p>
							<p className="text-primary p-13">L = lactose-free (Note: the portion of the raita and mint sauce and the spread butter on naan bread may contain lactose. Be sure to ask for lactose-free substitutes instead.)</p>
							<p className="text-danger p-13">G = gluten-free (Note: naan bread included in portions contains gluten.)</p>
							<p className="text-success p-13">V = vegan (Note: remember to ask)</p>
							<p className="text-primary p-13">P = Nuts Free</p>
							<p className="text-success p-13">M = Milk free</p>
							<p className="text-success p-13"><img src="/assets/img/chilly1.png" class="chill1" alt="img"/> Mild Spicy  &nbsp; ||  &nbsp; <img src="/assets/img/chilly2.png" class="chill1" alt="img"/> Medium Spicy  &nbsp; ||  &nbsp; <img src="/assets/img/chilly3.png" class="chill1" alt="img"/> Extra Spicy</p>
						</div>
					</div>
					</div>
				</div>
			</div>

        }
}

export default GroupMenu